<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input class="filter-item" v-model="listQuery.order_no" placeholder="请输入订单号" style="width: 250px;" clearable/>
      <el-select class="filter-item" filterable v-model="listQuery.ledger_role_id" placeholder="分账角色" style="width: 140px" clearable>
        <el-option v-for="item in schoolLedgerRoles" :key="item.id" :label="item.role_name" :value="item.id">
        </el-option>
      </el-select>
      <el-select class="filter-item" v-model="listQuery.ledger_type" placeholder="分账类型" style="width: 140px" clearable>
        <el-option label="无" :value="0"></el-option>
        <el-option label="系统分账" :value="1"></el-option>
        <el-option label="微信分账" :value="2"></el-option>
        <el-option label="富友分账" :value="3"></el-option>
      </el-select>
      <el-date-picker v-model="listQuery.start_time" class="filter-item" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" default-time="00:00:00" placeholder="开始日期" clearable></el-date-picker>
      <el-date-picker v-model="listQuery.end_time" class="filter-item" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59" placeholder="截止日期" clearable></el-date-picker>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
      <el-button class="filter-item" type="primary" @click="handleExportExcel">导出</el-button>
      <el-button class="filter-item" type="primary" style="float:right" @click="$router.go(-1)">返回</el-button>
    </div>
    <div style="margin-bottom:10px;">
      <span style="font-size:18px;">总额：{{total_money}}</span>
      <span style="font-size:18px;margin-left:20px;">订单数：{{total}}</span>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="序号" width="60">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
          <!-- {{ scope.row.id }} -->
        </template>
      </el-table-column>
      <el-table-column label="订单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>
      <el-table-column label="商家名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_order ? scope.row.user_order.shop.shop_name : "" }}
        </template>
      </el-table-column>
      <el-table-column label="分账单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.sp_order_no }}
        </template>
      </el-table-column>
      <el-table-column label="角色名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.school_ledger_role.role_name }}
        </template>
      </el-table-column>
      <el-table-column label="分账账户" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.account }}
        </template>
      </el-table-column>
      <el-table-column label="分账类型" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.user_order && scope.row.user_order.ledger_type === 1">系统分账</el-tag>
          <el-tag type="success" v-else-if="scope.row.user_order && scope.row.user_order.ledger_type === 2">微信分账</el-tag>
          <el-tag type="warning" v-else-if="scope.row.user_order && scope.row.user_order.ledger_type === 3">富友分账</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="金额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.money }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="下单时间" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.user_order ? scope.row.user_order.created_at : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="分账时间" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column label="分账结果" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.result === 'PENDING'">待分账</span>
          <span v-else-if="scope.row.result === 'SUCCESS'">分账成功</span>
          <span v-else-if="scope.row.result === 'CLOSED'">分账失败已关闭</span>
          <span v-else>{{ scope.row.result }}</span>
        </template>
      </el-table-column>
      <el-table-column label="分账失败原因" min-width="150" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.fail_reason === 'ACCOUNT_ABNORMAL'">分账接收账户异常</span>
          <span v-else-if="scope.row.fail_reason === 'NO_RELATION'">分账关系已解除</span>
          <span v-else-if="scope.row.fail_reason === 'RECEIVER_HIGH_RISK'">高风险接收方</span>
          <span v-else-if="scope.row.fail_reason === 'RECEIVER_REAL_NAME_NOT_VERIFIED'">接收方未实名</span>
          <span v-else-if="scope.row.fail_reason === 'NO_AUTH'">分账权限已解除</span>
          <span v-else-if="scope.row.fail_reason === 'RECEIVER_RECEIPT_LIMIT'">接收方已达收款限额</span>
          <span v-else-if="scope.row.fail_reason === 'PAYER_ACCOUNT_ABNORMAL'">分出方账户异常</span>
          <span v-else>{{ scope.row.fail_reason }}</span>
        </template>
      </el-table-column>
    </el-table>

    <el-table
      v-loading="listLoading"
      :data="exportExcels"
      element-loading-text="Loading"
      fit
      highlight-current-row
      style="display: none"
      id="exportTable"
    >
      <el-table-column align="center" label="序号" width="60">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
          <!-- {{ scope.row.id }} -->
        </template>
      </el-table-column>
      <el-table-column label="订单号" min-width="110" align="center">
        <template slot-scope="scope">
          `{{ scope.row.order_no }}
        </template>
      </el-table-column>
      <el-table-column label="商家名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_order ? scope.row.user_order.shop.shop_name : "" }}
        </template>
      </el-table-column>
      <el-table-column label="分账单号" min-width="110" align="center">
        <template slot-scope="scope">
          `{{ scope.row.sp_order_no }}
        </template>
      </el-table-column>
      <el-table-column label="角色名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.school_ledger_role.role_name }}
        </template>
      </el-table-column>
      <el-table-column label="分账账户" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.account }}
        </template>
      </el-table-column>
      <el-table-column label="分账类型" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.user_order && scope.row.user_order.ledger_type === 1">系统分账</el-tag>
          <el-tag type="success" v-else-if="scope.row.user_order && scope.row.user_order.ledger_type === 2">微信分账</el-tag>
          <el-tag type="warning" v-else-if="scope.row.user_order && scope.row.user_order.ledger_type === 3">富友分账</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="金额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.money }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="下单时间" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.user_order ? scope.row.user_order.created_at : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="分账时间" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column label="分账结果" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.result === 'PENDING'">待分账</span>
          <span v-else-if="scope.row.result === 'SUCCESS'">分账成功</span>
          <span v-else-if="scope.row.result === 'CLOSED'">分账失败已关闭</span>
          <span v-else>{{ scope.row.result }}</span>
        </template>
      </el-table-column>
      <el-table-column label="分账失败原因" min-width="150" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.fail_reason === 'ACCOUNT_ABNORMAL'">分账接收账户异常</span>
          <span v-else-if="scope.row.fail_reason === 'NO_RELATION'">分账关系已解除</span>
          <span v-else-if="scope.row.fail_reason === 'RECEIVER_HIGH_RISK'">高风险接收方</span>
          <span v-else-if="scope.row.fail_reason === 'RECEIVER_REAL_NAME_NOT_VERIFIED'">接收方未实名</span>
          <span v-else-if="scope.row.fail_reason === 'NO_AUTH'">分账权限已解除</span>
          <span v-else-if="scope.row.fail_reason === 'RECEIVER_RECEIPT_LIMIT'">接收方已达收款限额</span>
          <span v-else-if="scope.row.fail_reason === 'PAYER_ACCOUNT_ABNORMAL'">分出方账户异常</span>
          <span v-else>{{ scope.row.fail_reason }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[5, 10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form
        ref="form"
        :model="form"
        label-position="left"
        label-width="70px"
      >
        <el-form-item label="电话号码" prop="name" style="width: 80%">
          <el-select
            v-model="form.phone"
            filterable
            remote
            reserve-keyword
            placeholder="请输入电话号码"
            :remote-method="getPhoneList"
            :loading="loading"
          >
            <el-option
              v-for="item in phoneList"
              :key="item.id"
              :label="item.phone"
              :value="item.phone"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog title="支付方式修改" :visible.sync="dialogVisible1" width="30%">
      <el-radio-group v-model="pay_method.pay_method">
        <el-radio label="weixin">微信支付</el-radio>
        <el-radio label="ccb">建行支付</el-radio>
        <el-radio label="sp">服务商支付</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="handleStore">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import AMapPosition from "@/components/AMapPosition";
import { mapGetters } from "vuex";
import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
  components: {
    AMapPosition,
  },
  data() {
    return {
      list: null,
      total: null,
      btnLoading: false,
      listLoading: true,
      loading: false,
      phoneList: [],
      listQuery: {
        page: 1,
        limit: 10,
        school_id: "",
        ledger_role_id:"",
        order_no: "",
        ledger_type: "",
        start_time: "",
        end_time: "",
      },
      total_money: 0,
      dialogVisible: false,
      dialogVisible1: false,
      form: {
        id: null,
        ledger_role_id: "",
        phone: "",
      },
      pay_method: {
        id: "",
        pay_method: "",
      },
      inputVisible: false,
      inputValue: "",
      schoolLedgerRoles: [],
      exportExcels: [],
    };
  },
  created() {
    if (this.$route.query.ledger_role_id) {
      this.listQuery.ledger_role_id = this.$route.query.ledger_role_id-0;
    }
    if (this.$route.query.order_no) {
      this.listQuery.order_no = this.$route.query.order_no;
    }
    this.getList();
    this.getSchoolLedgerRoleList();
  },
  computed: {
    ...mapGetters(["school_id"]),
  },
  watch: {
    school_id(newVal, oldVal) {
      this.listQuery.school_id = newVal;
      this.form.school_id = newVal;
      this.getList();
      this.getSchoolLedgerRoleList();
    },
    dialogVisible(newVal, oldVal) {
      // 编辑框一异隐藏，马上清除旧数据
      if (newVal === false) {
        this.form = {
          id: null,
          ledger_role_id: "",
          phone: "",
        };
        this.form.ledger_role_id = this.$route.query.ledger_role_id;
      }
    },
  },
  methods: {
    getList() {
      this.listLoading = true;
      this.listQuery.school_id = this.school_id;
      request({
        url: "/api/backend/school/revenueLog",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data.data;
        this.total = response.data.data.total;
        this.total_money = response.data.total_money;
        this.listLoading = false;
      });
    },
    getSchoolLedgerRoleList() {
      request({
        url: "/api/backend/school/ledgerRoleList",
        method: "get",
        params: {
          page: 1,
          limit: 100000,
          school_id: this.school_id
        }
      }).then(response => {
        this.schoolLedgerRoles = response.data.data;
      });
    },
    getPhoneList(query) {
      this.loading = true;
      if (query !== "") {
        request({
          url: "/api/backend/school/phoneList",
          method: "get",
          params: {
            phone: query,
            ledger_role_id: this.listQuery.ledger_role_id,
          },
        }).then((response) => {
          this.phoneList = response.data;
          this.loading = false;
        });
      } else {
        this.phoneList = [];
      }
    },
    choosePosition(res) {
      console.log(res);
      this.form.lng = res.position.lng;
      this.form.lat = res.position.lat;
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleClose(tag) {
      this.form.contact.splice(this.form.contact.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.form.contact.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    handleEdit(item) {
      this.form = item;
      this.dialogVisible = true;
    },
    getLedgerRoleDetail(id) {
      request({
        url: "/api/backend/school/ledgerRoleDetail",
        method: "get",
        params: { id: id },
      }).then((response) => {
        this.form = response.data;
        this.form.income_type = this.form.income_type + "";
        console.log(this.form);
      });
    },
    handleDel(item) {
      this.$confirm("确定要删除该绑定关系吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request({
          url: "/api/backend/school/phoneDel",
          method: "get",
          params: {
            id: item.id,
          },
        }).then(() => {
          // 删除最后一条数据时无数据问题
          this.list.length <= 1 ? this.listQuery.page-- : false;
          this.getList();
          this.$store.dispatch("GetSchools");
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
      });
    },
    handleUse(item) {
      this.listLoading = true;
      request({
        url: "/api/backend/school/use",
        method: "get",
        params: {
          id: item.id,
        },
      }).then(() => {
        this.getList();
        this.$store.dispatch("GetSchools");
        this.$message({
          type: "success",
          message: "操作成功!",
        });
      });
    },
    saveData() {
      if (!this.form.phone) {
        this.$message({
          type: "warning",
          message: "请输入手机号码",
        });
        return;
      }
      this.btnLoading = true;
      request({
        url: "/api/backend/school/phoneStore",
        method: "post",
        data: this.form,
      })
        .then(() => {
          this.btnLoading = false;
          this.dialogVisible = false;
          this.getList();
          this.$store.dispatch("GetSchools");
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    show(item) {
      this.pay_method.id = item.id;
      this.pay_method.pay_method = item.pay_method;
      this.dialogVisible1 = true;
    },
    handleStore() {
      this.$confirm("确定修改学校的支付方式吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request({
          url: "/api/backend/school/payMethodStore",
          method: "get",
          params: this.pay_method,
        }).then(() => {
          this.dialogVisible1 = false;
          this.getList();
          this.$store.dispatch("GetSchools");
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
      });
    },
    handleExportExcel() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery))
      listQuery.page = 1
      listQuery.limit = this.total
      request({
        url: "/api/backend/school/revenueLog",
        method: "get",
        params: listQuery
      }).then(response => {
        this.exportExcels = response.data.data.data
        this.$nextTick(function() {
          let wb = XLSX.utils.table_to_book(document.querySelector("#exportTable"));
          /* get binary string as output */
          let wbout = XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: true,
            type: "array"
          });
          try {
            FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), "分账收入记录.xlsx");
          } catch (e) {
            if (typeof console !== "undefined") console.log(e, wbout);
          }
        })
      })
    }
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.el-tag {
  margin-right: 10px;
}
.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 140px;
  vertical-align: bottom;
}
.input {
  display: flex;
}
</style>
